import React from "react";
import {inject, observer} from "mobx-react";
import DesktopNavigation from "@components/Navigation/DesktopNavigation";



@inject("store")
@observer
export default class TopBarBeriksson extends React.Component {
    constructor(props) {
        super(props);

        this.logout = this.logout.bind(this);
        this.chooseSite = this.chooseSite.bind(this);
        this.openNewOrder = this.openNewOrder.bind(this);
        this.navigateToChild = this.navigateToChild.bind(this);
    }


    logout(e) {
        e.preventDefault();
        this.props.store.account.Logout();
    }

    chooseSite(e) {
        e.preventDefault();
        this.props.store.navigation.openChoose();
    }

    openNewOrder(e) {
        e.preventDefault();
        this.props.store.navigation.openNewOrder();
    }


    navigateToChild(e, node) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        const myPagesTree = navigation.myPagesTree;

        //console.debug("e", node.Path, myPagesTree);
        myPagesTree.navigateToChild(node);
    }


    render() {

        //return (<div className="top-bar"></div>);
        const navigation = this.props.store.navigation;
        const account = this.props.store.account;

        const customerId = navigation.getCustomerId();
        const currentCustomer = account.Customers.find(x => x.Id === customerId);

        return (
            <div className="top-bar container-fluid">
                <div className={"right"}>

                    {/*{account.isLoggedIn*/}
                    {/*    ? <div className="hidden-sm-down"><a className="" href="" onClick={this.logout}><i className="material-icons lock_open"></i>Logga ut</a><span><i className="material-icons person"></i>{account.Email}</span></div>*/}
                    {/*    : <div className=""><a href={account.LoginUrl}><i className="material-icons lock"></i>Logga in</a></div>*/}
                    {/*}*/}

                    {!account.isLoggedIn 
                        ?<div><a href={account.LoginUrl} onClick={(e) => { e.preventDefault(); navigation.navigateToSiteUrl(null, account.LoginUrl)}}><i className="material-icons lock"></i>Logga in</a></div> 
                        :<div>
                            <span>
                                <a 
                                    className="customer-link" 
                                    href="#" 
                                    onClick={() => 
                                        (account.Customers && account.Customers.length !== 1)
                                            ? account.setShowSettingsDialog(true)
                                            : navigation.navigateToSiteUrl(null, account.ProfileUrl)
                                    }>
                                    <i className="material-icons domain"/>{currentCustomer && (currentCustomer.Name + " #" + currentCustomer.Number)}
                                </a>
                            </span>
                        </div>

                    }
                    
                        <DesktopNavigation
                            className="top-menu"
                            tree={navigation.marketSettings.MarketNavigationTree}/>
                        {/*<MarketSelector navigation={navigation} disconnectedPanel={true} />*/}
                    
                </div>
            </div>

        );
    }
}